// @mui
import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

export default styled((props) => <TextField type="number" {...props} />)(() => ({
  "& input": {
    "::-webkit-outer-spin-button": {
      WebkitAppearance: "inner-spin-button !important",
    },
    "::-webkit-inner-spin-button": {
      WebkitAppearance: "inner-spin-button !important",
    },
  },
}));
